import { useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { DashboardFormWrapper } from '../../dashboard';
import { YardCompaniesPage } from './YardCompaniesComponents';
import { CompanyViewHeader, CompanyViewForm } from '../CompanyViewComponents';
import { useYardCompanyQuery } from '../../../hooks';
import { RoleGuard } from '../../../routes';

export const YardCompaniesView = () => {
  const params: any = useParams();
  const { data, isFetching } = useYardCompanyQuery({ id: params.id });
  const [isEdit, setIsEdit] = useState(false);

  if (isFetching) return <></>;
  if (!data) return <Navigate to={'/dashboard/yardcompanies'} replace />;

  return (
    <RoleGuard roles={['SUPER_ADMIN']}>
      <YardCompaniesPage>
        <CompanyViewHeader
          data={data}
          belongsTo={'YARD_COMPANY'}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
        />
        <DashboardFormWrapper flow={'row'}>
          <CompanyViewForm data={data} />
          <CompanyViewHeader
            data={data}
            belongsTo={'YARD_COMPANY'}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            showOnlySubmit
          />
        </DashboardFormWrapper>
      </YardCompaniesPage>
    </RoleGuard>
  );
};
